import script from "./psiStoreLossGainOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./psiStoreLossGainOrder.vue?vue&type=script&setup=true&lang=js"

import "./psiStoreLossGainOrder.vue?vue&type=style&index=0&id=0983c4a2&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0983c4a2"]])

export default __exports__